<div>
    <a (click)="exitScreen()" style="cursor: pointer"><i-tabler name="x" style="color: #666; font-size: 32px; position: absolute; right: 10px; top: 10px"></i-tabler></a>
    <div style="display: flex; padding: 20px;">
        <img src="assets/images/logos/clu-dark-logo.svg" alt="logo" style="width: 130px; margin: auto;">
    </div>
    <div style="font-weight: 600;font-size: 28px;margin-bottom: 10px;">Cauris Linkup</div>
    <div style="font-weight: 600;">Initialisation du mot de passe</div>
    <div style="font-weight: 600;margin-bottom: 20px;">Veuillez remplir les champs ci-dessous pour initialiser votre mot de passe</div>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <form class="m-t-30" [formGroup]="form" (ngSubmit)="submit()">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Nouveau mot de passe</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input matInput type="password" formControlName="NewPassword" />
                      <mat-hint *ngIf="f['NewPassword'].touched && f['NewPassword'].invalid" class="m-b-16 error-msg">
                        <div class="text-error" *ngIf="f['NewPassword'].errors && f['NewPassword'].errors['required']">
                          Veuillez saisir un nouveau mot de passe
                        </div>
                      </mat-hint>
                    </mat-form-field>
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Confirmer mot de passe</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input matInput type="password" formControlName="ConfirmPassword" />
                      <mat-hint *ngIf="f['ConfirmPassword'].touched && f['ConfirmPassword'].invalid" class="m-b-16 error-msg">
                        <div class="text-error" *ngIf="f['ConfirmPassword'].errors && f['ConfirmPassword'].errors['required']">
                          Veuillez confirmer le mot de passe
                        </div>
                      </mat-hint>
                    </mat-form-field>
                    <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
                    <div class="error-container" *ngIf="form.hasError('PasswordNotSame')">
                        Les mot de passe ne correspondent pas.
                    </div>
                    <button mat-flat-button color="primary" class="w-100" [disabled]="!form.valid || loading">
                      <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
                      <ng-container *ngIf="!loading">Valider</ng-container>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>